import { isAccountFeatureEnabled } from "owa-feature-flags";
import { isSingleLineListView } from "owa-mail-layout";
import { type TableQueryType, type TableView } from "owa-mail-list-store";
import getMailboxInfo from "owa-mail-mailboxinfo/lib/getMailboxInfo";
import { getShowPreviewLinesInListView, PreviewLinesOption } from "owa-messagelist-layout-option";
import { getAccountScopeUserSettings } from "owa-session-store";

/**
 * Returns the number of preview lines to render for a table. In search results, a user
 * who has turned Message Preview off is shown a single preview line when
 * sea-alwaysShowSearchCaptions is on. The saved setting is not changed, and the admin
 * policy that disables previews always wins, whether it is set globally or on the table's account.
 */
export default function getPreviewLinesForTable(tableView: TableView, showPreviewTextDisabled: boolean): number {
    const numMessagePreviewLines = getShowPreviewLinesInListView();
    const mailboxInfo = getMailboxInfo(tableView);
    if (!showPreviewTextDisabled &&
        numMessagePreviewLines === PreviewLinesOption.Off &&
        tableView.tableQuery.type === 1 &&
        !getAccountScopeUserSettings(mailboxInfo).PolicySettings?.MessagePreviewsDisabled &&
        isAccountFeatureEnabled("sea-alwaysShowSearchCaptions", mailboxInfo)) {
        return isSingleLineListView() ? PreviewLinesOption.Inline : PreviewLinesOption.OneLine;
    }
    
    return numMessagePreviewLines;
}
